import { helper } from '@ember/component/helper';

import { ITEM_STRUCTURE_TYPE_IDS } from 'rise-ui/utils/model/item.js';

/**
 * `item-type-id` template helper
 * Provides item model typeId for the given special constant string to assist in
 * template logic around item typeId, e.g. with `item-type-id-eq` helper.
 * Note: if you have access to an actual item, better to use item model type
 * flags, e.g. item.isTimeSeries, item.isGeospatial, item.isBinary.
 * @param {string} itemTypeKey Constant from ITEM_STRUCTURE_TYPE_IDS
 * @return {*}
 */
export default helper(function itemTypeIdHelper([ itemTypeKey ]) {
  return ITEM_STRUCTURE_TYPE_IDS[itemTypeKey];
});
